import { Verse } from './types';

export const joyVerses: Verse[] = [
  {
    text: "The joy of the Lord is your strength.",
    reference: "Nehemiah 8:10",
    why: "This verse highlights the power of joy in the Lord as a source of strength."
  },
  {
    text: "You make known to me the path of life; you will fill me with joy in your presence, with eternal pleasures at your right hand.",
    reference: "Psalm 16:11",
    why: "This verse reminds us that joy is found in God's presence and guidance."
  },
  {
    text: "Rejoice in the Lord always. I will say it again: Rejoice!",
    reference: "Philippians 4:4",
    why: "This verse encourages us to maintain joy in the Lord at all times."
  },
  {
    text: "The righteous will rejoice in the Lord and take refuge in Him; all the upright in heart will glory in Him!",
    reference: "Psalm 64:10",
    why: "This verse calls us to rejoice in the Lord as a refuge and protector."
  },
  {
    text: "You turned my wailing into dancing; you removed my sackcloth and clothed me with joy.",
    reference: "Psalm 30:11",
    why: "This verse reflects on God's transformative power to bring joy out of sorrow."
  },
  {
    text: "I have told you this so that my joy may be in you and that your joy may be complete.",
    reference: "John 15:11",
    why: "This verse shares the completeness of joy that comes through a relationship with Christ."
  },
  {
    text: "Shout for joy to the Lord, all the earth. Worship the Lord with gladness; come before Him with joyful songs.",
    reference: "Psalm 100:1-2",
    why: "This verse emphasizes joy in worshiping and praising God."
  },
  {
    text: "May the righteous be glad and rejoice before God; may they be happy and joyful.",
    reference: "Psalm 68:3",
    why: "This verse encourages the righteous to find happiness and joy in God's presence."
  },
  {
    text: "Rejoice greatly, Daughter Zion! Shout, Daughter Jerusalem! See, your king comes to you, righteous and victorious, lowly and riding on a donkey, on a colt, the foal of a donkey.",
    reference: "Zechariah 9:9",
    why: "This verse brings joy in the prophecy and fulfillment of Christ's coming as king."
  },
  {
    text: "For the joy set before Him, He endured the cross, scorning its shame, and sat down at the right hand of the throne of God.",
    reference: "Hebrews 12:2",
    why: "This verse reflects on the joy Jesus found in fulfilling God's plan, even in suffering."
  },
  {
    text: "A cheerful heart is good medicine, but a crushed spirit dries up the bones.",
    reference: "Proverbs 17:22",
    why: "This verse highlights the healing power of joy and a cheerful heart."
  },
  {
    text: "You will go out in joy and be led forth in peace; the mountains and hills will burst into song before you, and all the trees of the field will clap their hands.",
    reference: "Isaiah 55:12",
    why: "This verse paints a vivid picture of joy in God's creation and His guidance."
  },
  {
    text: "Though you have not seen Him, you love Him; and even though you do not see Him now, you believe in Him and are filled with an inexpressible and glorious joy.",
    reference: "1 Peter 1:8",
    why: "This verse speaks of the joy found in faith and love for Christ."
  },
  {
    text: "Be joyful in hope, patient in affliction, faithful in prayer.",
    reference: "Romans 12:12",
    why: "This verse ties joy to hope and encourages perseverance in difficult times."
  },
  {
    text: "You have made known to me the paths of life; You will fill me with joy in Your presence.",
    reference: "Acts 2:28",
    why: "This verse reminds us that true joy comes from walking in God's path."
  },
  {
    text: "The fruit of the Spirit is love, joy, peace, forbearance, kindness, goodness, faithfulness, gentleness, and self-control.",
    reference: "Galatians 5:22-23",
    why: "This verse emphasizes joy as a gift of the Holy Spirit in a Spirit-filled life."
  },
  {
    text: "The precepts of the Lord are right, giving joy to the heart. The commands of the Lord are radiant, giving light to the eyes.",
    reference: "Psalm 19:8",
    why: "This verse connects joy to the clarity and wisdom found in God's Word."
  },
  {
    text: "Rejoice with those who rejoice; mourn with those who mourn.",
    reference: "Romans 12:15",
    why: "This verse calls for shared joy and compassion within community and relationships."
  },
  {
    text: "Let the heavens rejoice, let the earth be glad; let the sea resound, and all that is in it.",
    reference: "Psalm 96:11",
    why: "This verse speaks of the joy and praise all creation offers to God."
  },
  {
    text: "The Lord has done great things for us, and we are filled with joy.",
    reference: "Psalm 126:3",
    why: "This verse celebrates God's works and the joy they bring."
  },
  {
    text: "Do not grieve, for the joy of the Lord is your strength.",
    reference: "Nehemiah 8:10",
    why: "This verse encourages us to draw strength from the joy of the Lord, even in hard times."
  },
  {
    text: "A person finds joy in giving an apt reply—and how good is a timely word!",
    reference: "Proverbs 15:23",
    why: "This verse shows how joy can come from thoughtful and encouraging words."
  },
  {
    text: "My lips will shout for joy when I sing praise to You—I whom You have delivered.",
    reference: "Psalm 71:23",
    why: "This verse highlights the joy that comes from praising God for His salvation."
  },
  {
    text: "Rejoice in the Lord and be glad, you righteous; sing, all you who are upright in heart!",
    reference: "Psalm 32:11",
    why: "This verse invites all the faithful to celebrate joyfully in the Lord."
  },
  {
    text: "Yet I will rejoice in the Lord, I will be joyful in God my Savior.",
    reference: "Habakkuk 3:18",
    why: "This verse expresses unwavering joy in God, even in challenging circumstances."
  },
  {
    text: "Sing for joy to God our strength; shout aloud to the God of Jacob!",
    reference: "Psalm 81:1",
    why: "This verse encourages us to celebrate God with joy and exuberance."
  },
  {
    text: "Those who sow with tears will reap with songs of joy.",
    reference: "Psalm 126:5",
    why: "This verse promises joy as a reward for enduring difficult seasons."
  },
  {
    text: "Your statutes are my heritage forever; they are the joy of my heart.",
    reference: "Psalm 119:111",
    why: "This verse connects the joy of the heart with following God's commands."
  },
  {
    text: "My soul will be satisfied as with the richest of foods; with singing lips my mouth will praise You.",
    reference: "Psalm 63:5",
    why: "This verse portrays joy and satisfaction found in praising God."
  }
];
